import {
  URL_SG_SET,
} from '../shared/action-names';
import { redirectUrlsActionTypes, redirectUrlsState } from './types';

const initialState: redirectUrlsState = {
  cascoRedirectURL: null,
  ownBodyshopRedirectURL: null,
  onMyOwnRedirectURL: null,
  redirectLinkSG: null,
  urlCreation: null,
  vmhEmbedRedirect: null,
};

export default function (
  state = initialState,
  action: redirectUrlsActionTypes,
): redirectUrlsState {
  switch (action.type) {
    case URL_SG_SET:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
